import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Container } from '@/components/generals/container'

interface PageHeaderProps {
    eyebrow: string
    title: ReactNode
    description?: ReactNode
    meta?: ReactNode
    children?: ReactNode
    className?: string
}

export const PageHeader: FC<PageHeaderProps> = ({
    eyebrow,
    title,
    description,
    meta,
    children,
    className
}): ReactNode => {
    return (
        <section className={cn('border-b border-border', className)}>
            <Container className='pb-10 pt-12 sm:pb-12 sm:pt-16 lg:pt-20'>
                <div className='max-w-3xl animate-in fade-in slide-in-from-bottom-2 duration-700 motion-reduce:animate-none'>
                    <p className='text-xs font-semibold uppercase tracking-[0.18em] text-brand'>
                        {eyebrow}
                    </p>

                    <h1 className='mt-4 font-heading text-[2.75rem] font-medium leading-[1.02] tracking-tight text-balance sm:text-6xl lg:text-7xl'>
                        {title}
                    </h1>

                    {description && (
                        <p className='mt-5 max-w-2xl text-lg leading-relaxed text-muted-foreground'>
                            {description}
                        </p>
                    )}

                    {meta && (
                        <p className='mt-5 text-sm font-medium text-foreground/70'>
                            {meta}
                        </p>
                    )}
                </div>

                {children && (
                    <div className='mt-9'>
                        {children}
                    </div>
                )}
            </Container>
        </section>
    )
}
